export default "__VITE_ASSET__DbJSRQ$s__"